export default {
  loadingDefault: {
    backgroundColor: 'rgba(53, 50, 57, 0.5)',
    position: 'fixed',
    zIndex: 999,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  iconLoading: {
    top: '50%',
    left: '50%',
    width: '48px',
    position: 'absolute',
    transform: 'translate(-50%, -50%)'
  }
};
